import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::create
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:28
* @route '/auth/register/info'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/auth/register/info',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::create
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:28
* @route '/auth/register/info'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::create
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:28
* @route '/auth/register/info'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::create
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:28
* @route '/auth/register/info'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::store
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:37
* @route '/auth/register/info'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/auth/register/info',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::store
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:37
* @route '/auth/register/info'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Register\RegisterInfoController::store
* @see app/Http/Controllers/Auth/User/Register/RegisterInfoController.php:37
* @route '/auth/register/info'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const info = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
}

export default info